// Shared immutable contract for the server-authoritative Stage 11 menu source.
// Keep this module dependency-free so both the access snapshot validator and
// route selector can import it without loading the Vuex store graph.
export const FULL_CATALOG_ROLLOUT_REVISION = 'stage11-all-capability-actions'



// WEBPACK FOOTER //
// ./src/router/iam-v2-route-contract.js